/* eslint-disable max-len */
import React from 'react';

const WarningIcon = ({ width = '13px', height = '14px', fill = '#6A2976' }) => (
  <svg width={width} height={height} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.22222 7.74123H5.77778V3.39649H7.22222V7.74123ZM5.77778 9.18948H7.22222V10.6377H5.77778V9.18948ZM9.19389 0.5H3.80611L0 4.31613V9.71809L3.80611 13.5342H9.19389L13 9.71809V4.31613L9.19389 0.5Z" fill={fill} />
  </svg>
);

export default WarningIcon;
